module.exports = {
	"en": {
		"about": {
			"whats_dddisc_title": "What's DDDisc?",
			"whats_dddisc_body_1": "DDDisc is a button badge with a special code embedded on the badge as a design. You can get content linked to the badge by scanning it with your smartphone.",
			"whats_dddisc_body_2": "Compared to regular barcode which are difficult to fit in design, DDDisc places the code to fit in the design, making it possible to add digital content value to a fashion item.",
			"whats_dddisc_body_3": "Beatrobo solely is responsible for manufacturing and providing the whole digital service.",
			"how_it_works_title": "How it works",
			"how_it_works_body_1": "By taking a photo of the badge through a smarthphone browser (Mobile Safari for iOS and Chrome for Android), we analyize the photo and read the code on our servers.",
			"how_it_works_body_2": "The badge have unique serial code, so we can use the dddisc button badge as DLC code nad one man one vote ticket etc..",
			"devices_title": "Compatible Devices/OS/Browser",
			"devices_body_ios": "iPhone, iPod touch, iPad / OS: iOS 8 or later / Browser: Mobile Safari",
			"devices_body_android": "Android Devices / OS: Android 4.4. or later /Browser : Chrome 50 or later",
			"solution_title": "What can DDDisc do?",
			"solution_body_1": "DDDisc has many use cases as giveaways, official merchandise of various sources, and as pre-order gifts for purchasing game content, etc.",
			"solution_body_2": "Keeping the pricing level as the same as regular button badges, we are able to satisfy the users by adding digital content (images, MP4, MP3, DLC codes, PDF, web links) to the item.",
			"solution_body_3": "Every badge has a unique code, therefore each badge can have its own DLC code. Instead of handing out cards and sheets, you can give out a \"badge\" to deliver these DLC codes.",
			"request_sample": "Request Sample DDDisc",
			"contact_solution": "Business Inquiry",
			"solution_page": "Solution details",
			"showcase_page": "Showcase"
		},
		"help": {
			"title": "Help",
			"devices_title": "Compatible Devices/OS/Browser",
			"devices_body_ios": "iPhone, iPod touch, iPad / OS: iOS 8 or later / Browser: Mobile Safari",
			"devices_body_android": "Android Devices / OS: Android 4.4. or later /Browser : Chrome 50 or later",
			"fails_title": "Disc (badge) fails to scan",
			"fails_body_1": "DDDisc scans the code on the front side of the badge.",
			"fails_body_2": "Please check the following points and try scanning multiple times.",
			"fails_tips_title": "Tips for scanning",
			"fails_tips_body_1": "Please focus the camera on the badge so the code shows properly.",
			"fails_tips_body_2": "If the badge is in a clear package, please take it out from the package before you take the photo.",
			"fails_tips_body_3": "Try not to be in a very light / very dark environment. A normal light environment helps recognize the badge the best.",
			"fails_tips_body_4": "Placing the badge on your palm makes the scanning process easier.",
			"fails_tips_body_5": "Please scan the front side of the badge.",
			"fails_tips_body_6": "Please avoid shadows or reflections on the badge.",
			"fails_tips_body_7": "Do not use flash when taking a photo of the badge.",
			"fails_tips_body_8": "Even if we call it a disc, we cannot read or scan CD/DVD/BD. Only use DDDisc products.",
			"fails_tips_body_9": "Internet connection is required to recognize and scan the badge. Please be in an environment with stable internet connection.",
			"fails_tips_body_10": "Try reloading the webpage when the scanning is not working.",
			"fails_tips_body_11": "Please check if you are using a compatible device and OS.",
			"photos": "Examples of Good and Bad photos",
			"focus_title": "Badge does not focus properly",
			"focus_body_1": "After launching the camera, focus on the front of the disc so it would show on the screen.",
			"focus_body_2": "Next, tap the disc showing inside the screen. The camera will focus to the disc.",
			"focus_body_3": "Make sure the disc is not blurry, so the bars on the code show properly.",
			"black_screen_title": "A black screen shows on the camera",
			"black_screen_body_1": "If you are using iOS 9, you have might done a setting before to not allow camera usage on Safari. If you do this setting, a black screen will appear on your camera screen.",
			"black_screen_body_2": "You can fix this by allowing camera access to Safari changing the privacy settings.",
			"black_screen_body_3": "Please retry scanning after you've changed the settings.",
			"black_screen_01": "1. Open \"Settings\" and choose \"Privacy\"",
			"black_screen_02": "2. Choose \"Camera\"",
			"black_screen_03": "3. If \"Safari\" setting switch is off, move it to the right to turn it ON",
			"no_content_title": "Content is not showing/playing",
			"no_content_body": "Digital content will be shown/played from our online servers. Please access with a stable internet connection environment.",
			"defect_title": "If you have a defected badge",
			"defect_body": "If you have a badge that is dirty, missing a pin, broken in some way, please contact us through user support reporting us that you have a defect. We will quickly provide a new one and replace it for you.",
			"contact_form": "Open contact form",
			"other_title": "If you are still in trouble",
			"other_body": "Please contact us through the form to let us know what is happening. We will be happy to help you out."
		},
		"request": {
			"sample_title": "Request DDDisc Sample",
			"sample_body_1": "We will send you various types of DDDisc for free.",
			"sample_body_2": "Please fill in the form below and send the request to us.",
			"sample_body_3": "We will deliver you the samples in 1 - 2 weeks.",
			"sample_email": "Email",
			"sample_email_2": "Email (confirm)",
			"sample_company": "Company",
			"sample_name": "Name",
			"zipcode": "Zipcode",
			"address": "Address",
			"number": "Order amount",
			"other": "Other (optional)",
			"send": "Send Request",
			"sending": "Sending..."
		},
		"request_alert_no_company": {
			"undefined": "Please fill in your company name."
		},
		"request_alert_no_name": {
			"undefined": "Please fill in your name."
		},
		"request_alert_no_zipcode": {
			"undefined": "Please fiil in your zipcode."
		},
		"request_alert_no_address": {
			"undefined": "Please fill in your address."
		},
		"request_alert_no_number": {
			"undefined": "Please fill in the order amount you are planning."
		},
		"contact": {
			"title": "Contact",
			"body_1": "Please contact us through the following forms",
			"user_support": "User Support",
			"solution": "Business opportunities",
			"other": "Other",
			"mail": "We also accept contact from email.",
			"body_2": "Please enter your email address, name, and your description.",
			"body_mail": "Email",
			"body_mail_confirm": "Email (confirm)",
			"name": "Name (optional)",
			"name_company": "Company / Name",
			"body_support": "Description (Issue, Device information)",
			"body_normal": "Description",
			"button_send": "Send",
			"button_sending": "Sending...",
			"alert_no_mail": "Please fill in your email address.",
			"alert_no_mail_confirm": "Please fill in your email address (confirm).",
			"alert_no_body": "Please fill in your description.",
			"alert_not_match_mail": "Your email address does not match.",
			"finish_title": "Inquiry sent",
			"finish_body_1": "We will reply to you in 2 business days.",
			"finish_body_2": "Thank you for your patience.",
			"finish_body_3": "If you are a docomo, au , Softbank user with a PC email refusal setting on your carrier email address, please change your settings so you can receive emails from \"support@dddisc.zendesk.com\" \"support@dddisc.com\" \"contact@dddisc.com\"",
			"back_to_home": "Return to Home"
		},
		"tos": {
			"title": "Terms of Service"
		},
		"privacy": {
			"title": "Privacy Policy"
		},
		"nav": {
			"home": "Home",
			"whats_dddisc": "What's DDDisc",
			"showcase": "Showcase",
			"scan": "Scan the Badge",
			"service": "Service",
			"user_support": "User Support",
			"information": "Information",
			"contact_user_support": "User Support",
			"contact_solution": "Business opportunities",
			"contact_other": "Contact (Other)",
			"contact_mail": "Contact (Email)",
			"solutions": "Solutions",
			"online_store": "Online Store"
		},
		"howto": {
			"title": "How to use"
		},
		"pc": {
			"body_1": "DDDisc is only available on smartphones and tablets.",
			"body_2": "Please access",
			"body_3": "by Android or iPhone."
		},
		"scan_result": {
			"common_error_1": "Place the disc on your hand,",
			"common_error_2": "and take a photo of the frontside of the disc.",
			"error_title": "Scan Failed.",
			"retry": "Retry Scan",
			"decoding": "Scanning",
			"uploading": "Uploading Image",
			"show_content": "Show Content",
			"show_contents_list": "Show Content List"
		},
		"instruction": {
			"title": "Scan Badge",
			"body_1": "By tapping [ Start Camera ] , a popup will show. Please select [ Take Photo ] here.",
			"body_2": "Please be in a light place, place the disc on your hand, and take a photo of the frontside of the disc.",
			"camera": "Start Camera"
		},
		"home": {
			"concept": "One more thing. DDDisc",
			"howto_1": "1. Scan with Phone Camera",
			"howto_2": "2. Get extra content",
			"scan": "Start Scan"
		},
		"showcase": {
			"title": "DDDisc Showcase",
			"body_1": "Listed are DDDisc use cases publicly known."
		},
		"content": {
			"url_not_found": "URL not found."
		},
		"notice": {
			"title": "Notice"
		},
		"company": {
			"title": "Company Overview"
		}
	},
	"ja": {
		"about": {
			"whats_dddisc_title": "DDDisc (ディーディーディスク) とは?",
			"whats_dddisc_body_1": "バッジやシールにユニークなコードをデザインの一部として埋め込み、そのコードをスマホで読み取ることで、 そのバッジに紐付いているコンテンツをゲットすることができるサービスです。",
			"whats_dddisc_body_2": "普通のバーコードは意匠に馴染みにくいものですが、DDDiscではデザインを邪魔しないようにコードを配置することにより、 ファッションアイテムとしてのグッズにデジタルコンテンツという価値を付け加えることができるようになっています。",
			"whats_dddisc_body_3": "DDDiscのサービス提供/運用、バッジなどの製造は、一括してBeatroboが責任を持って行っております。",
			"how_it_works_title": "DDDiscのしくみ",
			"how_it_works_body_1": "iOSのMobile SafariやAndroid Chromeなどのスマホのブラウザ上でバッジの写真を撮ることで、 その写真をサーバ上で解析しコードの読取りを行います。",
			"how_it_works_body_2": "バッジごとにユニークなシリアルコードが割り振られているので、DLCコードの配布や1バッジ1票制の投票チケットとしても利用することができます。",
			"devices_title": "DDDiscを利用できるデバイス/OS/ブラウザ",
			"devices_body_ios": "iOS8 以降のiPhone, iPod touch, iPad の Mobile Safari",
			"devices_body_android": "Android4.4 以降のAndroidデバイス の Chrome 50以降",
			"solution_title": "DDDiscソリューション",
			"solution_body_1": "現在DDDiscは様々なアーティストやグループのオフィシャルグッズとして、またはゲームなどの購入(予約)特典として多数採用されている実績がございます。",
			"solution_body_2": "缶バッジなどのグッズと同レベルの価格帯で、グッズ自体に様々なデジタルコンテンツ（画像、MP4、MP3、DLCコード、PDF、Webサイトへのリンク） を付け加えるができ、ユーザの満足度をより高めることができます。",
			"solution_body_3": "また、バッジにはユニークコードが割り振られているため、各バッジごとにユニークなDLCコードを紐付けることができます。 これにより、音楽やゲームなどの各プラットフォームのDLCコードをカードや紙ではない「バッジ」として配布することが可能となっています。",
			"request_sample": "無料サンプル請求",
			"contact_solution": "問い合わせフォーム",
			"solution_page": "ソリューションの詳細を見る",
			"showcase_page": "採用事例を見る"
		},
		"help": {
			"title": "ヘルプ",
			"devices_title": "DDDiscを利用できるOS/デバイス/ブラウザ",
			"devices_body_ios": "iOS8 以降のiPhone, iPod touch, iPad の Mobile Safari",
			"devices_body_android": "Android4.4 以降のAndroidデバイス の Chrome 50以降",
			"fails_title": "ディスク(バッジ)の認識に失敗する",
			"fails_body_1": "DDDiscは、ディスク表面のバーコードを認識していますので、撮影環境によって認識しない可能性があります。",
			"fails_body_2": "以下の点を注意して何度かスキャンをお試しください。",
			"fails_tips_title": "スキャン時のコツ",
			"fails_tips_body_1": "白黒コードのラインがはっきり見えるようにバッジにフォーカスを合わせて撮影してください (カメラのフォーカスがバッジに合わない)",
			"fails_tips_body_2": "ディスクが透明包装に入っている場合は、透明包装から取り出して撮影してください",
			"fails_tips_body_3": "極端に暗い/明るい場所を避け、普通の室内光の下で撮影してください",
			"fails_tips_body_4": "ディスクは手のひらに載せて撮影してください",
			"fails_tips_body_5": "ディスクの正面から撮影してください",
			"fails_tips_body_6": "ディスクに影がかからないようにしてください",
			"fails_tips_body_7": "カメラのフラッシュは利用せず撮影してください",
			"fails_tips_body_8": "CD/DVD/BDなどのディスクは読み込めません。バッジやシールなどのDDDisc製品を撮影してください",
			"fails_tips_body_9": "ディスクの認識にはインターネットを利用するので、安定したインターネット環境下でスキャンを行ってください",
			"fails_tips_body_10": "一度DDDiscのページを再読込(リロード)してください",
			"fails_tips_body_11": "対応デバイス/OSかを確認してください",
			"photos": "撮影画像のOK & NG例",
			"focus_title": "カメラのフォーカスがディスク(バッジ)に合わない",
			"focus_body_1": "カメラが立ち上がったあと、ディスクの正面がカメラに収まるようにカメラを構えます。",
			"focus_body_2": "そして、画面内のディスクの中央をタップすると、ディスクにフォーカスが合うようになります。",
			"focus_body_3": "多少ディスクが小さく写っても大丈夫ですので、ディスクのバーコードの白黒のバーの境界がはっきり見えるようにフォーカスをちゃんと合わせて撮影するようにしてください。",
			"black_screen_title": "カメラ画面で真っ黒の画面が表示される (iOS)",
			"black_screen_body_1": "iOS9の場合、カメラ画面で本来カメラ映像が映る画面が真っ黒の表示となりシャッターが押せない状況になっていることがあります。",
			"black_screen_body_2": "その場合はプライバシー設定にて、Safariでのカメラ利用をONにする必要があります。",
			"black_screen_body_3": "以下の指示に従い設定を行い、再度ブラウザにてDDDiscを撮影してください。",
			"black_screen_01": "①「設定」アプリを起動し、「プライバシー」の項目を選択します。",
			"black_screen_02": "②「カメラ」の項目を選択します。",
			"black_screen_03": "③「Safari」の設定がOFFになっている場合はスイッチを右に動かしONにしてください。",
			"no_content_title": "コンテンツが表示されない",
			"no_content_body": "コンテンツはすべて弊社サーバからダウンロードされますので、安定したインターネット環境下でご視聴ください。",
			"defect_title": "ディスク(バッジ)が不良品の場合",
			"defect_body": "バッジが汚れている、ピンがないなどの不良品がございましたら、お手数おかけいたしますが 問い合わせフォームから不良の旨をご連絡ください。迅速に交換対応させていただきます。",
			"contact_form": "お問い合わせフォームを開く",
			"other_title": "それでもお困りの方は…",
			"other_body": "お手数おかけいたしますが、問い合わせフォームから症状などをご連絡ください。早急に対応させていただきます。"
		},
		"request": {
			"sample_title": "無料サンプル請求",
			"sample_body_1": "缶バッチタイプのDDDiscを無料でお届けいたします。",
			"sample_body_2": "ご希望の方は以下の情報をすべて埋めてご送信ください。",
			"sample_body_3": "現在問い合わせ多数につき、到着まで1〜2週間ほどかかりますことをご了承ください。",
			"sample_email": "メールアドレス",
			"sample_email_2": "メールアドレス（確認）",
			"sample_company": "貴社名",
			"sample_name": "お名前",
			"zipcode": "郵便番号（ハイフンなし、例：1510031）",
			"address": "ご住所",
			"number": "ご検討されているご注文数",
			"other": "備考（オプション）",
			"send": "送信",
			"sending": "送信中..."
		},
		"request_alert_no_company": {
			"undefined": "貴社名が入力されていません。"
		},
		"request_alert_no_name": {
			"undefined": "お名前が入力されていません。"
		},
		"request_alert_no_zipcode": {
			"undefined": "郵便番号が入力されていません。"
		},
		"request_alert_no_address": {
			"undefined": "ご住所が入力されていません。"
		},
		"request_alert_no_number": {
			"undefined": "ご検討されているご注文数が入力されていません。"
		},
		"contact": {
			"title": "お問い合わせ",
			"body_1": "以下のお問い合わせフォームをご利用ください。",
			"user_support": "ユーザサポートに関するお問い合わせ",
			"solution": "DDDiscソリューションに関するお問い合わせ",
			"other": "その他のお問い合わせ",
			"mail": "メールでのお問合わせも受け付けております。",
			"body_2": "以下のフォームにて、メールアドレス、お名前、問い合わせ内容をご入力ください。",
			"body_mail": "メールアドレス",
			"body_mail_confirm": "メールアドレス (確認)",
			"name": "お名前 (省略可)",
			"name_company": "御社名/お名前",
			"body_support": "お問い合わせ内容 (症状、ご利用の端末など)",
			"body_normal": "お問い合わせ内容",
			"button_send": "送信",
			"button_sending": "送信中...",
			"alert_no_mail": "メールアドレスが入力されていません。",
			"alert_no_mail_confirm": "メールアドレス(確認)が入力されていません。",
			"alert_no_body": "お問い合わせ内容が入力されていません。",
			"alert_not_match_mail": "確認用のメールアドレスが一致していません。",
			"finish_title": "お問い合わせを承りました",
			"finish_body_1": "2営業日以内にご指定のメールアドレスに返信させていただきます。",
			"finish_body_2": "今しばらくお待ち下さい。",
			"finish_body_3": "docomo, au, SoftBankなどのキャリアメールをご利用の方で、PCメール受信拒否をされている場合は、「support@dddisc.zendesk.com」「support@dddisc.com」「contact@dddisc.com」からのメールを拒否しない設定にしてください。",
			"back_to_home": "ホームに戻る"
		},
		"tos": {
			"title": "利用規約"
		},
		"privacy": {
			"title": "プライバシーポリシー"
		},
		"nav": {
			"home": "ホーム",
			"whats_dddisc": "DDDiscとは",
			"showcase": "採用事例",
			"scan": "バッジをスキャン",
			"service": "サービス",
			"user_support": "ユーザサポート",
			"information": "情報",
			"contact_user_support": "ユーザサポートに関して",
			"contact_solution": "DDDiscソリューションに関して",
			"contact_other": "その他お問い合わせ",
			"contact_mail": "メールでお問い合わせ",
			"solutions": "ソリューション",
			"online_store": "オンラインストア"
		},
		"howto": {
			"title": "DDDiscの使い方"
		},
		"pc": {
			"body_1": "DDDisc はスマートフォンやタブレットでのみご利用いただけます。",
			"body_2": "Android, iPhone などで",
			"body_3": "にアクセスしてください。"
		},
		"scan_result": {
			"common_error_1": "ディスクを手のひらに載せ、",
			"common_error_2": "ディスクの正面から撮影してください。",
			"error_title": "認識に失敗しました。",
			"retry": "もう一回スキャン",
			"decoding": "ディスクを認識中",
			"uploading": "画像をアップロード中",
			"show_content": "コンテンツを表示",
			"show_contents_list": "コンテンツリストを表示"
		},
		"instruction": {
			"title": "バッジをスキャンする",
			"body_1": "下の「カメラを起動」ボタンを押すとポップアップが表示されるので「写真を撮る」をタップしてください。",
			"body_2": "なるべく明るい環境で、ディスクを手のひらに載せてディスクの正面から撮影してください。",
			"camera": "カメラを起動"
		},
		"home": {
			"concept": "楽しさ、見た目以上。DDDisc",
			"howto_1": "①カメラでスキャン",
			"howto_2": "②コンテンツをゲット",
			"scan": "バッジをスキャンする"
		},
		"showcase": {
			"title": "DDDiscの採用事例",
			"body_1": "公開可能なDDDisc採用事例を掲載しています。"
		},
		"content": {
			"url_not_found": "URLが指定されていません。"
		},
		"notice": {
			"title": "お知らせ"
		},
		"company": {
			"title": "会社概要"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales.json
// module id = 880
// module chunks = 38